import type { IAuditRequest } from "@/entities/audit-request/types.ts"
import { ENERGY_AUDIT_REQUESTS_API_URL } from "@/features/energy-audit/constants.ts"
import { requestIntensity } from "@/shared/utils/axios.ts"

export async function fetchAuditRequestById(id: string) {
  const { data } = await requestIntensity.get(`${ENERGY_AUDIT_REQUESTS_API_URL}/${id}`)
  return data as IAuditRequest
}
